export default "/kiban/_next/static/images/14_6L_2-2-2_withoutBH-a9a4ca002fa1e925689fbf0f56ac3694.png";